import { TrackingEvents, track } from "#webapp/src/util/analytics.util";
import { logger } from "#webapp/src/util/logger.util";
import { Button, Link } from "@clockwise/design-system";
import { CWIDProps } from "@clockwise/web-commons/src/util/cw-id.util";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import React, { ReactElement } from "react";
import { useLogout } from "../hooks/useLogout";

interface IProps extends CWIDProps {
  isMenuItem?: boolean;
  menuItemIcon?: ReactElement;
  anchor?: boolean;
  onLogout?: () => void;
}

export const LogoutBtn = ({
  anchor,
  isMenuItem,
  menuItemIcon,
  onLogout,
  "cw-id": cwId,
}: IProps & CWIDProps) => {
  const [logoutUser] = useLogout({
    onError: (error) => logger.error("An error occurred on logout", error),
  });

  const logout = async () => {
    track(TrackingEvents.AUTH.BEGIN_LOGOUT);
    await logoutUser();
    onLogout?.();
  };

  if (anchor) {
    return (
      <Link cw-id={cwId} onClick={logout}>
        Sign out
      </Link>
    );
  } else if (isMenuItem) {
    return (
      <MenuItem cw-id={cwId} aria-label="Sign out" onClick={logout}>
        {menuItemIcon && <ListItemIcon>{menuItemIcon}</ListItemIcon>}
        <ListItemText inset primary="Sign out" />
      </MenuItem>
    );
  } else {
    return (
      <Button cw-id={cwId} onClick={logout}>
        <span>Sign out</span>
      </Button>
    );
  }
};
